import { type BillingInterval } from 'entities/Billing/api/types'

const BILLING_INTERVAL_TO_LABEL: Record<BillingInterval, string> = {
  annual: 'year',
  'semi-annual': '6 months',
  quarterly: 'quarter',
  monthly: 'month',
}

const INTERVAL_TO_MONTH: Record<BillingInterval, number> = {
  annual: 12,
  ['semi-annual']: 6,
  quarterly: 3,
  monthly: 1,
}

export function getIntervalMonthCount(interval: BillingInterval) {
  return INTERVAL_TO_MONTH[interval]
}

export function getBillingLabel(interval: BillingInterval) {
  return BILLING_INTERVAL_TO_LABEL[interval]
}
